export default __webpack_public_path__ + "static/media/security_health.5eb30a50.svg";